import { render, staticRenderFns } from "./DesignLibraryModal.vue?vue&type=template&id=c01fafc8&"
import script from "./DesignLibraryModal.vue?vue&type=script&lang=ts&"
export * from "./DesignLibraryModal.vue?vue&type=script&lang=ts&"
import style0 from "./DesignLibraryModal.vue?vue&type=style&index=0&id=c01fafc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports